import React from "react";

export const Loader = () => {
  return (
    <>
      {/* <div className="aqua-loader-main">
            <p>
                <img className="" src="https://cdn.shopify.com/s/files/1/0084/6957/7794/files/Fish2.gif?50060" alt="Aqualens Contact lenses" />
            </p>
            
        </div> */}
      <div className="skeletorWrapper">
        <div className="skeletonContent">
          <div>
            <div className="flex justify-between skeleton skeleton_content">
              <div className=" content_1"></div>
              <div className=" content_2"></div>
            </div>
            <div className="flex justify-between skeleton skeleton_content">
              <div className="content_1"></div>
              <div className="content_2"></div>
            </div>
            <div className="skeleton skeleton_header "></div>

            <div className="flex justify-between skeleton skeleton_content">
              <div className="content_1"></div>
              <div className="content_2"></div>
            </div>
            <div className="flex justify-between skeleton skeleton_content">
              <div className="content_1"></div>
              <div className="content_2"></div>
            </div>
            
          </div>

          <div>
            <div className="flex justify-between skeleton skeleton_content">
              <div className="content_1"></div>
              <div className="content_2"></div>
            </div>

            <div className="skeleton skeleton_header "></div>
            <div className="skeleton skeleton_header "></div>

            <div className="flex justify-between skeleton skeleton_content">
              <div className="content_1"></div>
              <div className="content_2"></div>
            </div>

            <div className="flex justify-between skeleton skeleton_content">
              <div className="content_1"></div>
              <div className="content_2"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
